"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDeepMergeFn = exports.useNestedData = exports.nestData = exports.createNestDataHook = exports.createNestDataFn = void 0;

var react_1 = require("react");

exports.createNestDataFn = function (pathKeys) {
  return function (data) {
    return exports.nestData(data, pathKeys);
  };
};

exports.createNestDataHook = function (pathKeys) {
  return function (data) {
    return exports.useNestedData(data, pathKeys);
  };
};

exports.nestData = function (data, pathKeys) {
  if (pathKeys.length < 1) return data;
  var obj = {};
  var lastObj = obj;

  for (var i = 0; i < pathKeys.length; i++) {
    var key = pathKeys[i];
    lastObj[key] = {};

    if (i === pathKeys.length - 1) {
      lastObj[key] = data;
    }

    lastObj = lastObj[key];
  }

  return obj;
};

exports.useNestedData = function (data, pathKeys) {
  return react_1.useMemo(function () {
    return exports.nestData(data, pathKeys);
  }, __spreadArrays([data], pathKeys));
};

function createDeepMergeFn(_a) {
  var mergeStrategy = _a.mergeStrategy,
      decisionFn = _a.decisionFn;
  return function merge(object1, object2, path) {
    var obj1 = __assign({}, object1);

    for (var p in object2) {
      var propPath = (path ? path + "." : "") + p;
      if (!object2.hasOwnProperty(p)) continue;
      if (object2[p] === obj1[p]) continue;

      if (!obj1.hasOwnProperty(p)) {
        if (object2[p] !== undefined) {
          obj1[p] = object2[p];
        }

        continue;
      }

      if (decisionFn) {
        var skip = decisionFn(propPath, object1, object2).skip;
        if (skip) continue;
      }

      if (object2[p].constructor === Object) {
        obj1[p] = merge(obj1[p], object2[p], propPath);
      } else {
        if (mergeStrategy === "overrideLeftToRight") {
          if (!obj1.hasOwnProperty(p)) {
            obj1[p] = object2[p];
          }
        } else if (mergeStrategy === "overrideRightToLeft") {
          obj1[p] = object2[p];
        }
      }

      if (obj1[p] === undefined) delete obj1[p];
    }

    return obj1;
  };
}

exports.createDeepMergeFn = createDeepMergeFn;